export default __webpack_public_path__ + "static/media/sample-image-placeholder.267fee8c.svg";